import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import DiaryList from "../components/pages/list/DiaryList";
import Login from "../components/pages/login/Login";
import { useRecoilValue } from "recoil";
import { userState } from "../states/userState";
import SingleInput from "../components/pages/singleInput/SingleInput";
import DiaryMatrix from "../components/pages/matrix/DiaryMatrx";
import MultiInput from "../components/pages/multiInput/MultiInput";

const Router = () => {
  const user = useRecoilValue(userState);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route
            path="/"
            element={
              user?.isAuth ? (
                <>
                  <DiaryList />
                </>
              ) : (
                <>
                  <Login />
                </>
              )
            }
          />
          <Route
            path="/matrix"
            element={
              user?.isAuth ? (
                <>
                  <DiaryMatrix />
                </>
              ) : (
                <>
                  <Login />
                </>
              )
            }
          />
          <Route
            path="/singleInput"
            element={
              user?.isAuth ? (
                <>
                  <SingleInput />
                </>
              ) : (
                <>
                  <Login />
                </>
              )
            }
          />
          <Route
            path="/multiInput"
            element={
              user?.isAuth ? (
                <>
                  <MultiInput />
                </>
              ) : (
                <>
                  <Login />
                </>
              )
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
